var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"fill-height"},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('DashboardWidgetTermineAllgemein')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }